// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".one-sidebar-header__title[data-v-87858bf2]{font-size:1rem;letter-spacing:-.1px;margin-bottom:0;font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
